import { render, staticRenderFns } from "./DriverListAddNew.vue?vue&type=template&id=4b71ee42"
import script from "./DriverListAddNew.vue?vue&type=script&lang=js"
export * from "./DriverListAddNew.vue?vue&type=script&lang=js"
import style0 from "./DriverListAddNew.vue?vue&type=style&index=0&id=4b71ee42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports